/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type COMMENTS_TAB = "ALL_COMMENTS" | "FEATURED_COMMENTS" | "NONE" | "UNANSWERED_COMMENTS" | "%future added value";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "DOWNVOTE_DESC" | "REPLIES_DESC" | "UPVOTE_DESC" | "%future added value";
declare const _StreamQueryLocal$ref: unique symbol;
export type StreamQueryLocal$ref = typeof _StreamQueryLocal$ref;
export type StreamQueryLocal = {
    readonly storyID: string | null;
    readonly storyURL: string | null;
    readonly commentsOrderBy: COMMENT_SORT;
    readonly commentsTab: COMMENTS_TAB;
    readonly " $refType": StreamQueryLocal$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StreamQueryLocal",
    "type": "Local",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "storyID",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "storyURL",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "commentsOrderBy",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "commentsTab",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '2a6d20f0920aa24bb6a13a568db1a4a4';
export default node;
